import Loading from 'components/Loading';
import { sub } from 'date-fns';
import React, { useMemo } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BRAND_GREEN_PRIMARY, DARK_TEXT } from 'resources/constants/colors';
import useAppointments from 'state/appointments';
import useUser from 'state/user';
import styled from 'styled-components';
import AppointmentsList from './components/AppointmentsList';
import { NoAppointmentsState } from 'components/EmptyState';
import { AppointmentCardSkeleton, SkeletonList } from 'components/Skeleton';
import SubpageTopBar from '../../components/SubpageTopBar';
import { UserTypes } from 'resources/constants/config';

const Tab = styled.button`
    padding: 8px 0;
    flex: 1;
    background-color: transparent;
    border: none;
    color: ${DARK_TEXT};
    border-radius: 50px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    outline: none;
    &.active {
        background-color: ${BRAND_GREEN_PRIMARY};
        color: #fff;
    }
`;

const TabsContainer = styled.div`
    display: flex;
    gap: 4px;
    background: #f0f0f0;
    border-radius: 50px;
    padding: 4px;
    margin: 12px 0;
`;

const Calendar = ({ toggleMenu }) => {
    const [page, setPage] = useState(0);
    const [appointments, appointmentsDispatcher] = useAppointments();
    const [user] = useUser();
    const history = useHistory();

    const isTherapist = user?.current?.userType === UserTypes.THERAPIST;

    useEffect(() => {
        appointmentsDispatcher.fetchStart();
    }, []);

    const list = useMemo(() => {
        if(!appointments.list) return [];

        if (page === 0) {
            const list = appointments.list.filter(
                ({ date }) =>
                    new Date(date) > sub(new Date(), { hours: 1 })
            );
            const sorted = list.sort((a, b) => {
                return new Date(a.date) - new Date(b.date);
            });
           return sorted;
        } else {
            const list = appointments.list.filter(
                ({ date }) =>
                    new Date(date) < sub(new Date(), { hours: 1 })
            );
            const sorted = list.sort((a, b) => {
                return new Date(b.date) - new Date(a.date);
            });
            return sorted;
        }
    }, [appointments.list, page]);

    const emptyStateProps = isTherapist
        ? {
            title: 'Sin citas próximas',
            description: page === 0
                ? 'Aquí aparecerán las sesiones confirmadas con tus pacientes'
                : 'No tienes sesiones pasadas registradas',
        }
        : {
            title: 'No tienes citas programadas',
            description: page === 0
                ? 'Agenda tu primera sesión con un terapeuta profesional certificado'
                : 'No tienes sesiones pasadas registradas',
            onFindTherapists: page === 0 ? () => history.push('/terapeutas') : undefined,
        };

    return (
        <>
            <SubpageTopBar toggleMenu={toggleMenu} title="Citas" />
            <TabsContainer>
                <Tab
                    className={page === 0 ? 'active' : ''}
                    onClick={() => setPage(0)}
                >
                    Próximas
                </Tab>
                <Tab
                    className={page === 1 ? 'active' : ''}
                    onClick={() => setPage(1)}
                >
                    Pasadas
                </Tab>
            </TabsContainer>
            {appointments.fetching.state ? (
                <SkeletonList
                    count={3}
                    component={AppointmentCardSkeleton}
                />
            ) : list?.length === 0 ? (
                <NoAppointmentsState {...emptyStateProps} />
            ) : (
                <AppointmentsList list={list} isTherapist={isTherapist} />
            )}
        </>
    );
};

export default Calendar;
